import React from 'react';

/**
 * Long-press on touch opens the same menu the hover chevron opens with a mouse.
 *
 * 500ms, cancelled by moving more than a few pixels — so a scroll that starts
 * on a bubble never pops a menu. Mouse users have the chevron; a mouse
 * long-press would collide with text selection, so it is touch only.
 */
const HOLD_MS = 500;
const SLOP = 8;

export default function useLongPress(onLongPress, { enabled = true } = {}) {
	const timer = React.useRef(null);
	const origin = React.useRef(null);

	const clear = () => {
		if (timer.current) clearTimeout(timer.current);
		timer.current = null;
		origin.current = null;
	};

	React.useEffect(() => clear, []);

	return {
		onPointerDown: (e) => {
			if (!enabled || e.pointerType !== 'touch') return;
			origin.current = { x: e.clientX, y: e.clientY };
			timer.current = setTimeout(() => {
				timer.current = null;
				onLongPress?.();
			}, HOLD_MS);
		},
		onPointerMove: (e) => {
			const o = origin.current;
			if (!o || !timer.current) return;
			if (Math.abs(e.clientX - o.x) > SLOP || Math.abs(e.clientY - o.y) > SLOP) clear();
		},
		onPointerUp: clear,
		onPointerCancel: clear,
	};
}
